const config = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_YaF6j5D6n",
    userPoolWebClientId: "1vqumoeagc6dp5scnnt1qq4gd7",
  },
};

export default config;
